module.exports = __webpack_public_path__ + "img/flower.237f182a.png";